import { h, render } from 'preact'; // eslint-disable-line no-unused-vars

export const FavouriteIcon = () => (
  <div className="favourite-icon icon-wrapper">
    <svg className="icon icon__favourite" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30.42 29.23">
      <path className="foreground" d="M27.24,11.91h0M15.21,1a2.14,2.14,0,0,0-2,1.48L10.81,9.77H3.18a2.14,2.14,0,0,0-1.26,3.88L8.1,18.13,5.74,25.39A2.14,2.14,0,0,0,9,27.79l6.18-4.49,6.17,4.49a2.14,2.14,0,0,0,3.3-2.4l-2.37-7.26,6.17-4.49a2.14,2.14,0,0,0-1.26-3.88H19.61L17.24,2.51A2.15,2.15,0,0,0,15.21,1Z"/>
    </svg>
  </div>
);

export default () => {
  [...document.getElementsByTagName('FavouriteIcon')].forEach((el) => {
    render(FavouriteIcon(), el.parentElement, el.parentElement.lastChild);
  });
};
